import { addMinutes, format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import React from 'react'
import CreateNewEventEmptyGridBox from './CreateNewEventEmptyGridBox'
import LargeWeekViewAvailabilityPlaceholderChip from './LargeWeekViewAvailabilityPlaceholderChip'
import LargeWeekViewEventChips from "./LargeWeekViewEventChips"
import LargeWeekViewHorizontalLines from "./LargeWeekViewHorizontalLines"
import LargeWeekViewVerticalLines from "./LargeWeekViewVerticalLines"
import { convertStringToUTCString } from '../calendarFunctions'
import {
  getWeekCurrentTimeIndicatorPosition,
  WEEK_FIVE_MINUTE_ROW_HEIGHT,
  WEEK_GRID_TOP_OFFSET,
} from './weekViewCurrentTimeUtils'

const LargeWeekViewCalendar = ({containerOffset, weekViewEventObject, setEditEvent, setEventToEdit, displayedWeek, createNewCalendarEvent, schoolCalendar}) => {
  const [finalDateObject, setFinalDateObject] = React.useState(weekViewEventObject)
  const [currentTime, setCurrentTime] = React.useState(new Date())

  React.useEffect(() => {
    const timer = window.setInterval(() => setCurrentTime(new Date()), 60000)
    return () => window.clearInterval(timer)
  }, [])

  React.useEffect(() => createColumns(), [weekViewEventObject, displayedWeek])

  const createColumns = () => {
    const events = [...weekViewEventObject];
    const hash = {};
    let columns = 1;

  
    events.forEach((event) => {
      const time = new Date(event.dateTime).getTime();
      if (hash[time]) {
        hash[time]++;
        columns = Math.max(columns, hash[time]);
        event.column = hash[time];
      } else {
        hash[time] = 1;
        event.column = 1;
      }
    });
  
    setFinalDateObject(events);
  };

  const createNewEventByClickBlankSpace = (col, i) => {
    let fixedColumn = col === 0 ? 6 : col - 1
    let formattedDateTime = format(addMinutes(displayedWeek[fixedColumn], i * 5), "yyyy-MM-dd'T'HH:mm:ss")
    createNewCalendarEvent(convertStringToUTCString(formattedDateTime, schoolCalendar.timeZone))
  }

  const calendarCurrentTime = schoolCalendar?.timeZone
    ? utcToZonedTime(currentTime, schoolCalendar.timeZone)
    : currentTime
  const currentTimePosition = getWeekCurrentTimeIndicatorPosition(displayedWeek, calendarCurrentTime)

    return(
        <div className="flex flex-auto z-0">
          <div className="sticky left-0 z-10 w-14 flex-none bg-white ring-1 ring-gray-100" />
          <div className="relative grid flex-auto grid-cols-1 grid-rows-1">
            <LargeWeekViewHorizontalLines containerOffset={containerOffset} />
            <LargeWeekViewVerticalLines />
            <ol
              className='relative col-start-1 col-end-2 row-start-1 m-0 grid grid-cols-1 sm:grid-cols-7 sm:pr-0'
              style={{
                boxSizing: 'content-box',
                paddingTop: `${WEEK_GRID_TOP_OFFSET}px`,
                gridTemplateRows: `repeat(288, ${WEEK_FIVE_MINUTE_ROW_HEIGHT}px) auto`,
              }}
            >
              {currentTimePosition && (
                <li
                  className='calendar__week-current-time'
                  aria-label={`Current time ${format(calendarCurrentTime, 'h:mm a')}`}
                  style={{
                    top: `${currentTimePosition.topPx}px`,
                    left: `${currentTimePosition.leftPercent}%`,
                    width: `${currentTimePosition.widthPercent}%`,
                  }}
                />
              )}
              {Array.from(Array(288), (e, i) => (
                <CreateNewEventEmptyGridBox key={i} i={i} createNewEventByClickBlankSpace={createNewEventByClickBlankSpace} />
              ))}
              {finalDateObject.map((event) => 
                event.isAvailabilityPlaceholder ? 
                <LargeWeekViewAvailabilityPlaceholderChip key={event.id} event={event} />
                :
                <LargeWeekViewEventChips key={event.id} event={event} setEditEvent={setEditEvent} setEventToEdit={setEventToEdit} />
                )}
            </ol>
          </div>
        </div>
    )
}
export default LargeWeekViewCalendar;
